import { Controller } from "@hotwired/stimulus";

/**
 * 指定した値と一致するときだけ content ターゲットを表示するコントローラ
 *
 * Values:
 *   - current  : String  サーバーサイドの初期値（例: "true" / "false"）
 *   - showWhen : String  この値のときに content を表示する（例: "false"）
 *   - placeholderWhenShown : String  （任意）この値のときに field のプレースホルダーを差し替える文言
 *
 * Targets:
 *   - content  : 表示・非表示を切り替える要素（複数可）
 *   - field    : placeholderWhenShown を適用する入力欄（複数可）。それ以外のときは元のプレースホルダーに戻す
 *
 * Actions:
 *   - change->show-if#handleChange  ラジオボタン・セレクト等の change イベントに接続する
 *
 * Usage example:
 *   <div
 *     data-controller="show-if"
 *     data-show-if-current-value="<%= f.object.some_field.to_s %>"
 *     data-show-if-show-when-value="false"
 *   >
 *     <input type="radio" value="true"  data-action="change->show-if#handleChange">
 *     <input type="radio" value="false" data-action="change->show-if#handleChange">
 *     <p data-show-if-target="content">false のときだけ表示される文言</p>
 *   </div>
 *
 * Connects to data-controller="show-if"
 */
export default class extends Controller {
  static targets = ["content", "field"];
  static values = {
    current: String,
    showWhen: String,
    placeholderWhenShown: String,
  };

  connect() {
    // 元のプレースホルダーを退避してから差し替える
    for (const field of this.fieldTargets) {
      field.dataset.showIfDefaultPlaceholder = field.placeholder;
    }
    this.#update(this.currentValue);
  }

  // ラジオボタン・セレクト等の change イベントで呼ばれる
  handleChange(event) {
    this.#update(event.target.value);
  }

  #update(value) {
    const visible = value === this.showWhenValue;
    for (const target of this.contentTargets) {
      target.hidden = !visible;
    }
    if (!this.hasPlaceholderWhenShownValue) return;
    for (const field of this.fieldTargets) {
      field.placeholder = visible ? this.placeholderWhenShownValue : field.dataset.showIfDefaultPlaceholder;
    }
  }
}
